<template>
  <div class="box">
    <div class="d-flex upper_box sub_box">
      <div>
        <div class="label_text">
          {{ label }}
        </div>
        <div class="value_text">₹{{ data.investedAmount }}</div>
      </div>
      <v-spacer></v-spacer>
      <div>
        <div class="label_text">Current</div>
        <div class="value_text text-right">₹{{ data.currentAmount }}</div>
      </div>
    </div>
    <v-divider class=""></v-divider>
    <div class="d-flex sub_box">
      <div class="label_text">P&L</div>
      <v-spacer></v-spacer>
      <div
        class="value_text"
        :class="data.currentPnl >= 0 ? 'profit_color' : 'loss_profit'"
      >
        <span v-if="data.currentPnl > 0">+</span> {{ data.currentPnl }}
        <!-- ({{
          data.currentPnlPercent
        }}%) -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HighlightsCardMobile",
  props: {
    label: {
      default: "Capital",
      type: String,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.box {
  background: #f5f5f5;
  border-radius: 5px;
}
.sub_box {
  padding: 8px;
}
.label_text {
  color: rgba(51, 51, 51, 0.66);

  font-family: Avenir;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.value_text {
  color: #333;

  font-family: Avenir;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.profit_color {
  color: green;
}
.loss_color {
  color: red;
}
</style>
